"use client";

import { c as _c } from "react/compiler-runtime";
import { startTransition, useDeferredValue, useEffect, useMemo, useRef, useState } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import type { BlogCategory, BlogPost } from "@/lib/blog";
import { useResponsivePageSize } from "@/lib/use-responsive-page-size";
import { BlogCard } from "./blog-card";
import InputSearch from "./input-search";
import { useBlogListAnimation } from "./use-blog-list-animation";
type BlogListProps = {
  posts: BlogPost[];
  categories: BlogCategory[];
};
const ALL_FILTER = "Todos";
const PAGE_SIZE = 12;
const PAGE_SIZE_SM = 6;
function normalizeValue(value: string) {
  return value.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").trim().toLowerCase();
}
export function BlogList(t0) {
  const $ = _c(47);
  const {
    posts,
    categories
  } = t0;
  const gridRef = useRef(null);
  const pageSize = useResponsivePageSize(PAGE_SIZE, PAGE_SIZE_SM);
  const [activeFilter, setActiveFilter] = useState(ALL_FILTER);
  const [search, setSearch] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [visibleItems, setVisibleItems] = useState(pageSize);
  const deferredSearch = useDeferredValue(search);
  let t1;
  let t2;
  if ($[0] !== pageSize) {
    t1 = () => {
      setVisibleItems(pageSize);
    };
    t2 = [pageSize];
    $[0] = pageSize;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== categories) {
    t3 = [ALL_FILTER, ...categories.map(_temp)];
    $[3] = categories;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const filters = t3;
  let t4;
  bb0: {
    let t5;
    if ($[5] !== deferredSearch || $[6] !== posts) {
      const normalizedSearch = normalizeValue(deferredSearch);
      t5 = normalizedSearch ? posts.filter(post => normalizeValue(post.title).includes(normalizedSearch)) : posts;
      $[5] = deferredSearch;
      $[6] = posts;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    const searchedPosts = t5;
    if (activeFilter === ALL_FILTER) {
      t4 = searchedPosts;
      break bb0;
    }
    let t6;
    if ($[8] !== activeFilter) {
      t6 = normalizeValue(activeFilter);
      $[8] = activeFilter;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    const normalizedFilter = t6;
    let t7;
    if ($[10] !== normalizedFilter || $[11] !== searchedPosts) {
      let t8;
      if ($[13] !== normalizedFilter) {
        t8 = post_0 => post_0.categories.some(category_0 => normalizeValue(category_0.name) === normalizedFilter);
        $[13] = normalizedFilter;
        $[14] = t8;
      } else {
        t8 = $[14];
      }
      t7 = searchedPosts.filter(t8);
      $[10] = normalizedFilter;
      $[11] = searchedPosts;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t4 = t7;
  }
  const filteredPosts = t4;
  const visiblePosts = filteredPosts.slice(0, visibleItems);
  const canLoadMore = visibleItems < filteredPosts.length;
  const animationKey = visiblePosts.map(_temp2).join("|");
  useBlogListAnimation(gridRef, animationKey);
  const t5 = "blog-list-section relative text-white";
  let t6;
  if ($[15] !== activeFilter || $[16] !== filters || $[17] !== pageSize) {
    t6 = <div className="flex">{filters.map(filter => <ButtonRadialFill key={filter} className={["first:border-l border-x xl:border-r xl:max-w-fit border-gray-350 px-10 py-7 h-16 text-base leading-[160%] tracking-[0.01em] transition", activeFilter === filter ? "bg-primary-300 text-white" : "text-gray-100/70 hover:text-white"].join(" ")} classNameFill="bg-primary-300" onClick={() => {
        startTransition(() => {
          setActiveFilter(filter);
          setVisibleItems(pageSize);
        });
      }}>{filter}</ButtonRadialFill>)}</div>;
    $[15] = activeFilter;
    $[16] = filters;
    $[17] = pageSize;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== isSearchOpen || $[20] !== pageSize || $[21] !== search) {
    t7 = <div className="max-md:px-6"><InputSearch search={search} setSearch={setSearch} isSearchOpen={isSearchOpen} setIsSearchOpen={setIsSearchOpen} setVisibleItems={setVisibleItems} PAGE_SIZE={pageSize} /></div>;
    $[19] = isSearchOpen;
    $[20] = pageSize;
    $[21] = search;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className="hidden xl:block container border-x border-gray-300 max-md:pb-6"><div className="flex px-6 lg:px-18 3xl:px-24!"><div className="flex w-full flex-col items-start md:flex-row md:justify-between xl:items-center">{t6}{t7}</div></div></div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== activeFilter || $[27] !== filters || $[28] !== pageSize) {
    t9 = <div className="hidden md:block xl:hidden container md:border-x md:border-gray-300"><div className="flex px-6 lg:px-18">{filters.map(filter_0 => <ButtonRadialFill key={filter_0} className={["first:border-l border-x min-w-fit border-gray-350 px-5 lg:px-10 py-4 text-base leading-[160%] tracking-[0.01em] transition", activeFilter === filter_0 ? "bg-primary-300 text-white" : "text-gray-100/70 hover:text-white"].join(" ")} classNameFill="bg-primary-300" onClick={() => {
          startTransition(() => {
            setActiveFilter(filter_0);
            setVisibleItems(pageSize);
          });
        }}>{filter_0}</ButtonRadialFill>)}</div></div>;
    $[26] = activeFilter;
    $[27] = filters;
    $[28] = pageSize;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== activeFilter || $[31] !== filters || $[32] !== pageSize) {
    t10 = <div className="block md:hidden overflow-x-auto"><div className="flex">{filters.map(filter_1 => <ButtonRadialFill key={filter_1} className={["first:border-l border-x min-w-fit border-gray-350 px-10 py-4 text-base leading-[160%] tracking-[0.01em] transition", activeFilter === filter_1 ? "bg-primary-300 text-white" : "text-gray-100/70 hover:text-white"].join(" ")} classNameFill="bg-primary-300" onClick={() => {
          startTransition(() => {
            setActiveFilter(filter_1);
            setVisibleItems(pageSize);
          });
        }}>{filter_1}</ButtonRadialFill>)}</div></div>;
    $[30] = activeFilter;
    $[31] = filters;
    $[32] = pageSize;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t8 || $[36] !== t9) {
    t11 = <div className="md:container-padding sticky top-17 z-40 bg-gray-1000 backdrop-blur-xl border-y border-gray-300">{t8}{t9}{t10}</div>;
    $[34] = t10;
    $[35] = t8;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  const t12 = "md:container-padding";
  const t13 = "container relative md:border-x md:border-gray-300 px-6 lg:px-18 3xl:px-24!";
  let t14;
  if ($[38] !== pageSize || $[39] !== search) {
    t14 = <div className="block xl:hidden max-w-100 md:pt-8"><InputSearch search={search} setSearch={setSearch} isSearchOpen={true} setIsSearchOpen={setIsSearchOpen} setVisibleItems={setVisibleItems} PAGE_SIZE={pageSize} /></div>;
    $[38] = pageSize;
    $[39] = search;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const t15 = filteredPosts.length > 0 ? <><div ref={gridRef} className="grid gap-x-17 gap-y-25 pt-18 md:grid-cols-2 lg:grid-cols-3"><span className="hidden md:inline-flex absolute -top-1.75 -left-1.75 h-3 w-3 border border-gray-300 bg-gray-1000 z-40" /><span className="hidden md:inline-flex absolute -top-1.75 -right-1.75 h-3 w-3 border border-gray-300 bg-gray-1000 z-40" />{visiblePosts.map(_temp3)}</div>{canLoadMore ? <div className="flex justify-center px-6 py-16"><ButtonRadialFill className="group h-16 rounded-2xl border border-primary-300 bg-transparent px-6 text-[18px] font-medium transition-[background-color,color,box-shadow] duration-150 ease-out enabled:hover:shadow-[0_18px_35px_rgba(255,92,0,0.2)]" classNameFill="bg-primary-300" onClick={() => {
        setVisibleItems(current => current + pageSize);
      }}>Carregar mais</ButtonRadialFill></div> : <div className="h-16" />}</> : <div className="px-6 py-20 text-center text-gray-400 md:px-12 lg:px-18 3xl:px-24!">Nenhum post encontrado para essa busca.</div>;
  let t16;
  if ($[41] !== t14 || $[42] !== t15) {
    t16 = <div className={t12}><div className={t13}>{t14}{t15}</div></div>;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t11 || $[45] !== t16) {
    t17 = <section className={t5}>{t11}{t16}</section>;
    $[44] = t11;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
}
function _temp3(post_2, index) {
  return <BlogCard key={post_2.slug} post={post_2} priority={index === 0} />;
}
function _temp2(post_1) {
  return post_1.slug;
}
function _temp(category) {
  return category.name;
}